var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { PickType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsOptional, ValidateNested } from "class-validator";
export var TefcaProvider;
(function (TefcaProvider) {
    TefcaProvider["CommonWell"] = "CommonWell";
    TefcaProvider["MedAllies"] = "MedAllies";
})(TefcaProvider || (TefcaProvider = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["RO_CLEAR_LOGIN_FALLBACK"] = "RO_CLEAR_LOGIN_FALLBACK";
    FeatureFlag["CLEAR_LOGIN_FALLBACK_RESET"] = "CLEAR_LOGIN_FALLBACK_RESET";
    FeatureFlag["DOCUMENT_RETRIEVAL_PATIENT_FLOW"] = "DOCUMENT_RETRIEVAL_PATIENT_FLOW";
    FeatureFlag["PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN"] = "PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN";
    FeatureFlag["DATA_DELIVERY_PATH_AS_FILENAME_PREFIX"] = "DATA_DELIVERY_PATH_AS_FILENAME_PREFIX";
    FeatureFlag["TEFCA_PROVIDERS"] = "TEFCA_PROVIDERS";
    FeatureFlag["TEST"] = "TEST";
    FeatureFlag["TEST2"] = "TEST2";
    FeatureFlag["TEST3"] = "TEST3";
    FeatureFlag["TEST4"] = "TEST4";
})(FeatureFlag || (FeatureFlag = {}));
export const nullDecoder = () => null;
const dateDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    const date = new Date(rawConfig);
    return Number.isNaN(date.getTime()) ? null : date;
};
const createStringArrayDecoder = (enumType) => {
    const validValues = enumType ? new Set(Object.values(enumType)) : null;
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        try {
            const parsed = JSON.parse(rawConfig);
            if (!Array.isArray(parsed))
                return null;
            const isValidItem = (item) => typeof item === "string" && (!validValues || validValues.has(item));
            if (!parsed.every(isValidItem))
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    };
};
export const featureFlagConfigTypeMap = {
    [FeatureFlag.RO_CLEAR_LOGIN_FALLBACK]: nullDecoder,
    [FeatureFlag.DOCUMENT_RETRIEVAL_PATIENT_FLOW]: nullDecoder,
    [FeatureFlag.PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN]: nullDecoder,
    [FeatureFlag.DATA_DELIVERY_PATH_AS_FILENAME_PREFIX]: nullDecoder,
    [FeatureFlag.TEST]: nullDecoder,
    [FeatureFlag.CLEAR_LOGIN_FALLBACK_RESET]: dateDecoder,
    [FeatureFlag.TEST2]: dateDecoder,
    [FeatureFlag.TEST3]: createStringArrayDecoder(),
    [FeatureFlag.TEST4]: createStringArrayDecoder(TefcaProvider),
    [FeatureFlag.TEFCA_PROVIDERS]: createStringArrayDecoder(TefcaProvider),
};
export class Feature {
    constructor(fields) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
    decodeConfiguration() {
        try {
            return featureFlagConfigTypeMap[this.feature](this.configuration);
        }
        catch (error) {
            return null;
        }
    }
}
__decorate([
    IsEnum(FeatureFlag),
    __metadata("design:type", String)
], Feature.prototype, "feature", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], Feature.prototype, "enabled", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], Feature.prototype, "configuration", void 0);
export class FeatureUpdateInput extends PickType(Feature, ["feature", "enabled", "configuration"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class FeaturesDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Feature),
    __metadata("design:type", Array)
], FeaturesDto.prototype, "features", void 0);
